import { render, staticRenderFns } from "./RTransfers.vue?vue&type=template&id=0209448f&scoped=true"
import script from "./RTransfers.vue?vue&type=script&lang=js"
export * from "./RTransfers.vue?vue&type=script&lang=js"
import style0 from "./RTransfers.vue?vue&type=style&index=0&id=0209448f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0209448f",
  null
  
)

export default component.exports